module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASCAYAAABfJS4tAAAAmUlEQVQ4ja3UsQ2DMBAF0Aeih1kiRkAZgV0yQWZghcyQETJMmCApcJEC7GD7S6drTk+nk+VmWRYnc8EdM9ajofasGtArnuhrwjNeGGN4DrxiSuE58F94LpzES+AoXgof4h0+FfDfjHjX2Hg3LZoKNdhOIfShxsa97a5jQCespfAuStmrOERL4CiaCyfRXPiRQqHLgG+hRz/6L9D6LjfR7jIgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/news-jiantou.png
// module id = DR25
// module chunks = 1